export default __webpack_public_path__ + "static/media/EM0550.34I-41828_-25085_0.a3e62fa7.jpg";